// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListMoreChats-modulemoreChats__vnQRv";
var _2 = "GretaAIChatChatListMoreChats-modulemoreChatsText__YEGwG";
export { _1 as "moreChats", _2 as "moreChatsText" }
